(async () => {
  const el = document.getElementById('pressa-page')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/info/pressa/index.vue'),
    },
  ]

  await clientRender({ components })
})()
